(function () {
  function isV1(value) {
    var normalized = String(value || '').toLowerCase();
    return normalized === 'v1' || normalized === 'variant-1' || normalized === 'variation-1';
  }

  function getExperimentVariant(root) {
    var candidates = [root, document.body, document.documentElement];

    for (var i = 0; i < candidates.length; i += 1) {
      var node = candidates[i];
      if (!node) continue;

      var value = node.getAttribute('data-collection-exp') || node.getAttribute('data-collection-cro-exp');
      if (value) return value;
    }

    return 'control';
  }

  function applyCollectionVariant(root) {
    root.classList.toggle('collection-cro--v1', isV1(getExperimentVariant(root)));
  }

  function syncAll() {
    document.querySelectorAll('[data-collection-cro-root]').forEach(applyCollectionVariant);
  }

  function start() {
    var observer = new MutationObserver(syncAll);

    syncAll();

    if (document.body) {
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['data-collection-exp', 'data-collection-cro-exp']
      });
    }

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-collection-exp', 'data-collection-cro-exp']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
